module.exports = __webpack_public_path__ + "static/media/FromFilkers.ee8b9237.svg";